import { createV3Queries } from "@query/utils/createV3Queries";
import { auditLogsApi } from "@api";

export const queriesAuditLogs = createV3Queries("auditLogsApi", auditLogsApi);
